export const widgetTypesList = [
  {
    title: "Recipes",
    icon: "/img/new-icons/crockery.svg",
    description:
      "Create a digital library of your favorite recipes to share with users of your app",
    installNowlink:
      "`/actions/refresh?modal[type]=install-widget&widgetModal[type]=recipe`",
    learnmoreLink: "recipe",
  },
  {
    title: "Videos",
    icon: "/img/new-icons/desktop.svg",
    description:
      "Add course style or single videos to your app to share education with users of your app",
    installNowlink:
      "/actions/refresh?modal[type]=install-widget&widgetModal[type]=video-playlist",
    learnmoreLink: "video-playlist",
  },
  {
    title: "Macro calculator",
    icon: "/img/new-icons/calculator.svg",
    description:
      "Customize your own formula to provide goal-specific nutrition targets for your app users",
    installNowlink:
      "/actions/refresh?modal[type]=install-widget&widgetModal[type]=macro-calculator",
    learnmoreLink: "macro-calculator",
  },
  {
    title: "e-Commerce",
    icon: "/img/new-icons/store.svg",
    description:
      "Sell products and services directly in your app. Link stores, sponsors or affiliate links.",
    installNowlink:
      "/actions/refresh?modal[type]=install-widget&widgetModal[type]=store",
    learnmoreLink: "store",
  },
  {
    title: "Files and Documents",
    icon: "/img/new-icons/files.svg",
    description:
      "Embed PDFs, slides or any type of file directly in the app for your users to view.",
    installNowlink:
      "/actions/refresh?modal[type]=install-widget&widgetModal[type]=file-documents",
    learnmoreLink: "file-documents",
  },
  {
    title: "URL Links",
    icon: "/img/new-icons/url.svg",
    description: "Link any website URLs for app users to open inside your app",
    installNowlink:
      "/actions/refresh?modal[type]=install-widget&widgetModal[type]=links",
    learnmoreLink: "links",
  },
  {
    title: "Meal Plan Library",
    icon: "/img/new-icons/chef-hat.svg",
    description:
      "Embed meal plans as PDFs directly in the app for your users to use",
    installNowlink:
      "/actions/refresh?modal[type]=install-widget&widgetModal[type]=meal-plan-library",
    learnmoreLink: "meal-plan-library",
  },
  {
    title: "Daily Accountability Templates",
    icon: "/img/new-icons/checklist.svg",
    description:
      "Create a list of habits and assign to days of the week for your users to stay accountable",
    installNowlink:
      "/actions/refresh?modal[type]=install-widget&widgetModal[type]=daily-accountability-template",
    learnmoreLink: "daily-accountability-template",
  },
];

export const learnSections = {
  recipe: {
    banner: "/img/banners/Recipes.webp",
    title: "Recipes",
    description:
      "Create a digital library of your favorite recipes to share with users of your app",
    howWork: [
      "Add recipes details and a picture",
      "List the ingredients",
      "List the step by step instructions",
      "Add nutrition details by serving or batch",
    ],
    icons: [
      "/img/widget-icons/utensils.svg",
      "/img/widget-icons/utensils-alt.svg",
      "/img/widget-icons/apple-alt.svg",
      "/img/widget-icons/crockery.svg",
      "/img/widget-icons/pizza-slice.svg",
    ],
    installDescription: "Add a recipe widget to your app:",
  },
  "video-playlist": {
    banner: "/img/banners/Video.webp",
    title: "Videos",
    description:
      "Add course style or single videos to your app to share any content or education with users of your app",
    howWork: [
      "Create the content you want to add to the app",
      'Upload the videos to youtube as "unlisted"',
      "Add the video to a playlist by copy and pasting the share link",
      "List the step by step instructions",
      "Categorize videos into playlists or single videos",
    ],
    icons: [
      "/img/widget-icons/desktop.svg",
      "/img/widget-icons/film.svg",
      "/img/widget-icons/play-circle.svg",
      "/img/widget-icons/play.svg",
      "/img/widget-icons/tv-retro.svg",
    ],
    installDescription: "Add a video widget to your app:",
  },
  "macro-calculator": {
    banner: "/img/banners/MacroCalculator.webp",
    title: "Macro Calculator",
    description:
      "Customize your own macro-calculator to provide goal-specific nutrition targets for your app users",
    howWork: [
      "BMR (basal metabolic rate) is calculated using user inputs",
      "Using the activity level of the user, BMR is grossed up to find TDEE (total daily energy expenditure)",
      "You define your own calorie deficit and surplus for each goal (gain weight, lose weight and maintain)",
      "You define the macro nutrient splits for each goal that you want the calculator to prescribe",
    ],
    icons: [
      "/img/widget-icons/calculator.svg",
      "/img/widget-icons/calculator-alt.svg",
      "/img/widget-icons/clipboard-notes.svg",
    ],
    installDescription: "Add a custom macro calculator your app:",
  },
  store: {
    banner: "/img/banners/Ecommerce.webp",
    title: "e-Commerce",
    description:
      "Sell products and services directly in your app. Link your own stores, sponsors or affiliate links.",
    howWork: [
      "Add the URL for your e-commerce store (e.g. https://yourstore.com)",
      "Add a thumbnail picture (optional) * Meta preview of website will show as a default",
    ],
    icons: [
      "/img/widget-icons/bag.svg",
      "/img/widget-icons/bill.svg",
      "/img/widget-icons/money-bill.svg",
      "/img/widget-icons/shop.svg",
      "/img/widget-icons/shopping-bag.svg",
      "/img/widget-icons/shopping-cart.svg",
      "/img/widget-icons/store.svg",
      "/img/widget-icons/tag-alt.svg",
      "/img/widget-icons/wallet.svg",
    ],
    installDescription: "Add an e-Commerce widget to your app:",
  },
  "file-documents": {
    banner: "/img/banners/File.webp",
    title: "Files and Documents",
    description: "Embed PDF files directly in the app for your users to view",
    howWork: [
      "Create the PDF file you want to embed",
      "Upload the PDF to your account inside the widget manager",
      "Publish the widget on your app",
    ],
    icons: [
      "/img/widget-icons/document-alt.svg",
      "/img/widget-icons/folder-alt.svg",
      "/img/widget-icons/pdf-alt.svg",
    ],
    installDescription: "Add a files widget to your app:",
  },
  links: {
    banner: "/img/banners/Link.webp",
    title: "URL Links",
    description: "Embed URL links from any website to your app.",
    howWork: [
      "Add the URL link (e.g. https://yourwebsite.com)",
      "Add a thumbnail picture (optional) * Meta preview of website will show as a default",
    ],
    icons: ["/img/widget-icons/attachment.svg", "/img/widget-icons/link.svg"],
    installDescription: "Add a URL Links widget to your app:",
  },
  "meal-plan-library": {
    banner: "/img/banners/MealPlanLibrary.webp",
    title: "Meal Plan Library",
    description: "Embed meal plans directly in the app for your users to use",
    howWork: [
      "Create the PDF file you want to embed",
      "Upload the PDF to your account inside the widget manager",
      "Publish the widget on your app",
    ],
    icons: [
      "/img/widget-icons/meal1.svg",
      "/img/widget-icons/meal2.svg",
      "/img/widget-icons/meal3.svg",
      "/img/widget-icons/meal4.svg",
      "/img/widget-icons/meal5.svg",
    ],
    installDescription: "Add a meal plan library widget to your app:",
  },
  "daily-accountability-template": {
    banner: "/img/banners/DailyAccountability.webp",
    title: "Daily Accountability Templates",
    description:
      "Create a list of habits and assign to days of the week for your users to stay accountable",
    howWork: [
      "Think of a list of habits your users would like to track",
      "Create a template with a list of these habits and assign them to days of the week",
      "Publish the widget on your app",
    ],
    icons: [
      "/img/widget-icons/accountability1.svg",
      "/img/widget-icons/accountability2.svg",
      "/img/widget-icons/accountability3.svg",
      "/img/widget-icons/accountability4.svg",
      "/img/widget-icons/accountability5.svg",
    ],
    installDescription:
      "Add a daily accountability template widget to your app:",
  },
};
